import onReady from '@/scripts/modules/on-ready';

import './two-columns-carousel.scss';

function changeImageCallback( imageElement, newImageURL ) {
	imageElement.style.opacity = 0;
	setTimeout( () => {
		imageElement.style.backgroundImage = newImageURL;
		imageElement.style.opacity = 1;
	}, 300 );
}

function changeSlide( slide, carousel ) {
	const activeImage = carousel.querySelector( '.activeSlideImage' );
	const otherSlides = carousel.querySelectorAll( '.slideItem' );

	if ( ! slide.classList.contains( 'active' ) ) {
		otherSlides.forEach( function ( otherSlide ) {
			otherSlide.classList.remove( 'active' );
		} );
		slide.classList.add( 'active' );
		if ( slide.getAttribute( 'data-image' ) && activeImage ) {
			changeImageCallback(
				activeImage,
				'url(' + slide.getAttribute( 'data-image' ) + ')'
			);
		}
	}
}

function initAutoplay( carousel, activeTimeOut ) {
	if ( activeTimeOut ) {
		clearTimeout( activeTimeOut );
	}

	const newTimeout = setTimeout( function () {
		const firstSlide = carousel.querySelector( '.slideItem' );
		const nextSlide = carousel.querySelector(
			'.slideItem.active + .slideItem'
		);
		if ( nextSlide ) {
			changeSlide( nextSlide, carousel );
		} else {
			changeSlide( firstSlide, carousel );
		}
		initAutoplay( carousel, newTimeout );
	}, 7000 );
}

onReady( () => {
	const carousels = document.querySelectorAll(
		'.two-columns-carousel-block'
	);

	if ( 0 < carousels.length ) {
		carousels.forEach( function ( carousel ) {
			const slides = carousel.querySelectorAll( '.slideItem' );

			if ( 0 < slides.length ) {
				slides.forEach( function ( slide ) {
					const toggle = slide.querySelector( '.slideItemSelect' );
					toggle.addEventListener( 'click', function () {
						changeSlide( slide, carousel );
					} );
				} );

				initAutoplay( carousel );
			}
		} );
	}
} );
